<div class="col-12 col-lg-12 col-md-12 col-sm-12 col-xl-12 pl-0 pr-0 eb-cancel-modal-shell">
  <div class="border-0">
    <div class="mx-0 p-2 row div-container">
      <div class="col-xl-9 col-md-9 col-lg-9 col-9 pb-2 pt-2">
        <h5 id="messageModalLabel" class="font-24 font-ubuntu font-weight-600 modal-title font-style-normal">
          {{ title }}
        </h5>
      </div>
      <div class="col-xl-3 col-md-3 col-lg-3 col-3 pr-0 text-right">
        <button type="button" [attr.aria-label]="'Close Modal'" class="bg-transparent border-0" (click)="closePopup()">
          <img src="assets/images/close.png" alt="" />
        </button>
      </div>
    </div>
    <div class="row mx-0 pl-1 pr-1">
      <ng-template #errorContainer> </ng-template>
    </div>
    <div class="mt-2 modal-body pb-0 pl-2 pr-2" *ngIf="imageSrc && !showReason">
      <div class="mt-lg-2 mx-0 row">
        <div class="col-xl-12 text-center mb-2">
          <img [src]="imageSrc" alt="cancel bike purchase" />
        </div>
      </div>
    </div>
    <div class="mt-2 modal-body pb-0 pl-2 pr-2 eb-cancel-modal-content" *ngIf="showReason">
      <div class="mt-lg-2 mx-0 row">
        <div class="col-xl-12 text-left mb-2">
          <h3 class="font-16 font-weight-normal mt-0 mb-3">
            Please select a reason for cancelling your enrollment in the bike purchase program.
          </h3>
          <div [formGroup]="bikePurchaseClaimForm">
            <mdb-form-control>
              <mdb-select
                [attr.tabindex]="1"
                aria-label="CancellationReasons"
                role="combobox"
                id="CancellationReasons"
                required
                formControlName="CancellationReasons">
                <mdb-option
                  *ngFor="let reason of cancellationReasons; trackBy: trackByCancellationReason"
                  [value]="reason.idClaimCancellationReason"
                  role="option"
                  >{{ reason.cancellationReasonDescription }}</mdb-option
                >
              </mdb-select>
              <label mdbLabel class="form-label" for="CancellationReasons">Cancellation Reasons</label>
              <span
                class="error edenred-border-8"
                *ngIf="
                  bikePurchaseClaimForm.get('CancellationReasons').invalid &&
                  bikePurchaseClaimForm.get('CancellationReasons').hasError('required') &&
                  (bikePurchaseClaimForm.get('CancellationReasons').dirty ||
                    bikePurchaseClaimForm.get('CancellationReasons').touched)
                ">
                Please select a cancellation reason.
              </span>
            </mdb-form-control>
            <div *ngIf="showNotes">
              <h3 class="font-16 font-weight-normal mt-3 mb-3">Please specify (required)</h3>

              <mdb-form-control>
                <textarea
                  mdbInput
                  type="text"
                  id="Notes"
                  maxlength="500"
                  class="form-control eb-notes-textarea"
                  required
                  [attr.tabindex]="2"
                  formControlName="Notes"></textarea>
                <label mdbLabel class="form-label" for="Notes">Type something...</label>
                <span
                  class="error edenred-border-8"
                  *ngIf="
                    bikePurchaseClaimForm.get('Notes').invalid &&
                    bikePurchaseClaimForm.get('Notes').hasError('required') &&
                    (bikePurchaseClaimForm.get('Notes').dirty || bikePurchaseClaimForm.get('Notes').touched)
                  ">
                  Please specify notes for our reason for cancellation.
                </span>
              </mdb-form-control>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-body" *ngIf="!isHTML && !showReason">
      <div class="row mt-3">
        <p class="font-14 font-weight-normal mb-0">{{ message }}</p>
      </div>
    </div>
    <div
      class="modal-body contentMessageModal m-4 custom-scroll-table-scheduled"
      [attr.aria-label]="message"
      *ngIf="isHTML && !showReason">
      <div [innerHTML]="message | safeHTML"></div>
    </div>
  </div>
  <div class="mt-0 mt-lg-3 mx-0 pl-4 row mx-0 eb-cancel-modal-actions">
    <div class="col-lg-6 col-xl-4 text-lg-start mb-4 pt-2"></div>
    <div class="col-lg-12 col-xl-8 text-lg-end">
      <div class="mx-0 row justify-content-end mb-4">
        <button
          *ngIf="showCancelButton"
          id="cancelButton"
          name="cancelButton"
          [attr.aria-label]="'Dismiss Message'"
          class="btn btn-secondary btn-custom ms-3 pe-4 ps-4 ml-3 text-black w-auto font-12"
          (click)="closePopup()">
          {{ cancelText }}
        </button>
        <button
          *ngIf="showActionButton"
          id="actionButton"
          name="actionButton"
          class="btn btn-primary btn-custom ms-3 pe-4 ps-4 ml-3 text-black w-auto font-12"
          (click)="onClickAction(componentName)">
          {{ btnText }}
        </button>
      </div>
    </div>
  </div>
</div>
